import React from "react";

const Privacy: React.FC = () => {
  return (
    <main className="min-h-screen bg-white text-brandNavy py-20">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>

        <p className="text-base text-mutedGray mb-4">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Overview</h2>
          <p className="text-base text-mutedGray">
            We respect your privacy. This page explains what information we
            collect, why we collect it, and how we use it. By using our
            services, you agree to the collection and use of information in
            accordance with this policy.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">
            Information We Collect
          </h2>
          <ul className="list-disc pl-6 text-mutedGray space-y-2">
            <li>Contact information you provide (name, email, phone).</li>
            <li>Usage data such as pages visited and actions on the site.</li>
            <li>Form submissions and any content you choose to share.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">How We Use Data</h2>
          <p className="text-base text-mutedGray">
            We use collected information to:
          </p>
          <ul className="list-disc pl-6 text-mutedGray space-y-2">
            <li>Provide and maintain our services.</li>
            <li>
              Communicate about events, confirmations and important updates.
            </li>
            <li>Improve the website and user experience.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Third-Party Services</h2>
          <p className="text-base text-mutedGray">
            We may use third-party services (e.g., analytics, payment providers)
            who may process data on our behalf. We only share information
            necessary for those services to perform their functions.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Data Retention</h2>
          <p className="text-base text-mutedGray">
            We retain personal data only as long as necessary to provide our
            services or as required by law.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Your Rights</h2>
          <p className="text-base text-mutedGray">
            You can request access to, correction of, or deletion of your
            personal data. To make a request, please contact us via our Contact
            page.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Contact</h2>
          <p className="text-base text-mutedGray">
            If you have questions about this policy or wish to make a data
            request, visit our Contact page.
          </p>
        </section>

        <p className="text-sm text-mutedGray mt-8">
          This privacy policy is a simple summary and does not create any
          contractual rights. For detailed legal advice, consult your lawyer.
        </p>
      </div>
    </main>
  );
};

export default Privacy;
